import React from "react";
import { Box, Grid } from "@material-ui/core";
import EmployeeLinearStepper from "../EmployeeLinearStepper";
import HeaderMenu from "../../../../../Components/HeaderMenu";
import HomeHeaderMenu from "../../../../Home/HomeHeaderMenu";
import IconButton from "@material-ui/core/IconButton";
import { useHistory, useLocation } from "react-router-dom";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { useSelector } from "react-redux";
import { Typography } from "@material-ui/core";

const BOX_SHADOW = `0 13px 27px -5px hsl(240deg 30% 28% / 25%), 0 8px 16px -8px hsl(0deg 0% 0% / 30%), 0 -6px 16px -6px hsl(0deg 0% 0% / 3%)`;
const useStyles = makeStyles((theme) => ({
  root: {},
  organisationStepper: {
    backgroundColor: "white",
    position: "sticky",
    top: "64px",
    paddingTop: "5px",
    zIndex: 2,
  },
}));

export default function EmployeeCreate(props: any) {
  const classes = useStyles();
  const theme = useTheme();
  const globaluserData = useSelector((state: any) => state.commonReducer);

  const createEmployeeLayout = {
    width: "90%",
    margin: "0 auto",
    marginTop: "0px",
    postion: "sticky",
    top: "30%",
  };

  // const createEmployeeLayout = {
  //   width: "90%",
  //   margin: "0 auto",
  //   padding: "30px",
  //   // marginTop: '80px'
  // };
  const preStyles = {
    fontFamily: "inherit",
    margin: 0,
  };
  let history = useHistory();
  const location = useLocation();
  console.log("location", location.state);
  let userRole: any = {};
  userRole = globaluserData?.role || "";
  const movePreviousPage = () => {
    history.goBack();
  };

  const { first_name, last_name } = useSelector(
    (state: any) => state.contactAreaReducer.data
  );

  const empDetails = useSelector((state: any) => state.contactAreaReducer.data);
  const orgName = empDetails.organisation_name;

  console.log("orgDetails", orgName);

  return (
    <React.Fragment>
      {userRole === "employee" ? <HomeHeaderMenu /> : <HeaderMenu />}
      <div style={createEmployeeLayout}>
        <Box className={classes.organisationStepper} width='100%'>
          <Box
            width='100%'
            display='flex'
            justifyContent='space-between'
            alignItems='base-line'
          >
            <Box
              ml='1.5rem'
              bgcolor={theme.palette.secondary.main}
              mb='28px'
              mt='10px'
              width='fit-content'
              padding='10px 20px'
              borderRadius='4px'
              boxShadow={BOX_SHADOW}
            >
              <Typography
                component='span'
                variant='h2'
                style={{ color: "white" }}
              >
                <strong style={{ display: "inline-block", width: "170px" }}>
                  {" "}
                  Organisation name
                </strong>
                {/* @ts-ignore */}
                &#58; {location?.state?.orgName ?? orgName}
              </Typography>
              <br />
              {(first_name || last_name) && (
                <Typography
                  component='span'
                  variant='h2'
                  style={{
                    color: "white",
                    display: "inline-block",
                  }}
                >
                  {/* @ts-ignore */}
                  <strong style={{ display: "inline-block", width: "170px" }}>
                    Employee name
                  </strong>
                  &#58; {`${first_name ?? ""} ${last_name ?? ""}`}
                </Typography>
              )}
            </Box>
            {/* created details */}
            {props.edit === "yes" && (
              <Box display='flex' style={{ marginTop: "22px" }}>
                <Box>
                  <Typography variant='h2'>
                    <strong> Created by &nbsp; &nbsp; : </strong>
                    {empDetails?.created_by}
                  </Typography>
                  <Typography variant='h2'>
                    <strong>Created date : </strong>
                    {empDetails?.date_created}
                  </Typography>
                </Box>
                <Box ml='35px'>
                  <Typography variant='h2'>
                    <strong>Modified by &nbsp; &nbsp;&nbsp;: </strong>
                    {empDetails?.modified_by}
                  </Typography>
                  <Typography variant='h2'>
                    <strong>Modified date : </strong>
                    {empDetails?.date_modified}
                  </Typography>
                </Box>
              </Box>
            )}
          </Box>

          <Box display='flex' alignItems='center'>
            <IconButton onClick={movePreviousPage} edge='start'>
              <ArrowBackIosIcon style={{ fontSize: 25, color: "black" }} />
            </IconButton>
            <Typography variant='h1' style={{ fontWeight: "bold" }}>
              {userRole === "employee" || props.edit === "yes"
                ? "Edit employee profile"
                : "Create employee profile"}
            </Typography>
          </Box>
        </Box>
        <span style={{ top: "186px" }}>
          {/* moved this thing to the index.tsx */}
          {/* <UploadFilesComponentProvider> */}
          <EmployeeLinearStepper />
        </span>
      </div>
    </React.Fragment>
  );
}
